import { createSelector } from 'reselect'
import { State } from 'index'
import { ScheduleType } from 'types/schedule'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'

const scheduleSelector = (state: State) => state.schedule

export const getSchedules = createSelector([scheduleSelector], (state) => state.schedules)

export const getInitialScheduleValue = (
  breadRef: FirebaseDocRefType,
  scheduleRef: FirebaseDocRefType,
  type: StockUnionType,
  defaultSchedule?: ScheduleType
): ScheduleType => {
  return {
    bread_ref: breadRef,
    choices: defaultSchedule?.choices ?? [],
    days_of_week: [],
    default_stocks: [{ pickupable_time: '', stock: 0 }],
    hours_to_deadline: defaultSchedule?.hours_to_deadline ?? 12,
    maximum_order: defaultSchedule?.maximum_order ?? 1,
    note: defaultSchedule?.note ?? '',
    options: defaultSchedule?.options ?? [],
    schedule_ref: scheduleRef,
    type: type,
  }
}
